// action type strings
import * as actionTypes from '../../actionTypes';

export function updateTechnologySurvey(technologySurvey) {
  return {
    type: actionTypes.UPDATE_TECHNOLOGY_SURVEY,
    technologySurvey,
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/technologysurveys.js